export const ChatListHeaderStyle = {
  root: {
    backgroundColor: "var(--gray-50)",
    p: "0.8rem 1.6rem",
  },
  chatCount: {
    color: "var(--gray-350)",
    fontSize: "1.2rem",
    fontWeight: 500,
  },
  markAllAsRead: {
    color: "var(--orange-500)",
    fontSize: "1.2rem",
    fontWeight: 500,
  },
};
